import { IconCurrencyCircleDollar, Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import {
  Rule,
  RuleActions,
  RuleContent,
  RuleDefaultActions,
  RuleDescription,
  RuleIcon,
  Tag,
} from 'ui'
import { useNumbers } from 'ui/components/utils/useNumbers'
import { MaxPrice, RegularBenefitVariant } from '../../../../../../../typings'
import { ViewProps } from '../../View'
import { messages } from './messages'

type Props = ViewProps & {
  config: MaxPrice
}

export function MaxPriceView(props: Props) {
  const { onEdit, onRemove, config } = props

  const { formatCurrency } = useNumbers()

  const handleEdit = () => onEdit(RegularBenefitVariant.MaxPrice)

  return (
    <Rule onClick={handleEdit}>
      <RuleIcon>
        <IconCurrencyCircleDollar />
      </RuleIcon>

      <RuleDescription>
        <FormattedMessage
          {...messages.view.title}
          values={{
            b: (content) => <Text variant="body">{content}</Text>,
          }}
        />
      </RuleDescription>

      <RuleContent>
        <Tag>{formatCurrency(config.value)}</Tag>
      </RuleContent>

      <RuleActions>
        <RuleDefaultActions onEdit={handleEdit} onRemove={onRemove} />
      </RuleActions>
    </Rule>
  )
}
